import { createModule, mutation, action } from "vuex-class-component";
import User from "@/domain/user";
import api from "@/plugins/api";
import cookies from "@/plugins/cookies";

const VuexModule = createModule({
  namespaced: "auth",
  strict: false,
  target: "nuxt"
});

export default class AuthStore extends VuexModule {
  user: User | null = null;

  @mutation
  setUser(user: User | null) {
    this.user = user;
  }

  @action
  async fetchProfile() {
    try {
      const { data } = await api.get("/v3/auth/profile");
      this.setUser(data);
    } catch (err) {
      this.setUser(null);
    }
  }

  @action
  async setAccessToken(accessToken: string) {
    cookies.set("loquiz-creator.accessToken", accessToken);
  }

  @action
  async signOut() {
    cookies.remove("loquiz-creator.accessToken");
    this.setUser(null);
  }
}
